import UploadProgressBar from 'app/components/UploadProgressBar';

const CustomerUploadProgressBar = props => {
  const {
    customer,
    inModal
  } = props;

  //const matchFileContext = fileContext => {
  //  const {
  //    story_ids
  //  } = fileContext
  //
  //  return story_ids?.indexOf(customer.story_id) !== -1;
  //}
  let matchFileContext = {
    story_ids: [customer.story_id]
  }

  let total = customer.photo_count;
  let loaded = customer.actual_photo_count;

  return <UploadProgressBar {...{ matchFileContext, total, loaded, inModal }} />;
}

export default CustomerUploadProgressBar;
